export default function Services() {
  const services = [
    {
      title: 'Yacht Sales & Acquisitions',
      description: 'Strategic representation, valuation, and negotiation for buyers and sellers worldwide.',
      link: '/yacht-sales'
    },
    {
      title: 'Yacht Charter',
      description: 'Curated charter experiences and bespoke itineraries in the world\'s premier destinations.',
      link: '/yacht-charter'
    },
    {
      title: 'New Build Management',
      description: 'Expert guidance from concept development through construction and delivery.',
      link: '/new-build-management'
    },
    {
      title: 'Refit Management',
      description: 'Technical oversight and project management to enhance performance and long-term value.',
      link: '/refit-management'
    },
    {
      title: 'Crew Placement',
      description: 'Connecting experienced, professional crew with world-class yachts.',
      link: '/crew-placement'
    },
    {
      title: 'Yacht Financing',
      description: 'Strategic support navigating complex financing and transactional structures.',
      link: '/yacht-financing'
    }
  ];

  const handleServiceClick = (link?: string) => {
    if (link && window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(link);
    }
  };

  return (
    <section id="services" className="py-32 px-8 lg:px-16 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-20">
          <div className="w-20 h-px bg-black mb-8"></div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-black leading-tight">
            Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="group cursor-pointer"
              onClick={() => handleServiceClick(service.link)}
            >
              <div className="mb-6">
                <div className="w-12 h-px bg-black group-hover:w-20 transition-all duration-300"></div>
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-black mb-4 leading-tight">
                {service.title}
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
